import { combineReducers } from "redux";
import { RESPONSE_ERRORS, RESPONSE_SUCCESS, ACCESSIBILITY, ACCESSIBILITY_ACTIVE_SIZE, ACCESSIBILITY_ACTIVE_COLOR } from "../constants/global";

export function responseErrors(state = [], action) {
  switch (action.type) {
    case RESPONSE_ERRORS:
      return Array.isArray(action.errors) ? action.errors : [];
    default:
      return state;
  }
}

export function responseSuccess(state = [], action) {
  switch (action.type) {
    case RESPONSE_SUCCESS:
      return Array.isArray(action.success) ? action.success : [];
    default:
      return state;
  }
}

export function accessibility(state = false, action) {
  switch (action.type) {
    case ACCESSIBILITY:
      return action.bool;
    default:
      return state;
  }
}

export function accessibilityActiveSize(state = 0, action) {
  switch (action.type) {
    case ACCESSIBILITY_ACTIVE_SIZE:
      return typeof action.number === "number" && !isNaN(action.number) ? action.number : state;
    default:
      return state;
  }
}

export function accessibilityActiveColor(state = 0, action) {
  switch (action.type) {
    case ACCESSIBILITY_ACTIVE_COLOR:
      return typeof action.number === "number" && !isNaN(action.number) ? action.number : state;
    default:
      return state;
  }
}

export const globalReducers = () =>
  combineReducers({
    responseErrors: responseErrors,
    responseSuccess: responseSuccess,
    accessibility: accessibility,
    accessibilityActiveSize: accessibilityActiveSize,
    accessibilityActiveColor: accessibilityActiveColor,
  });
